<template>
    <AppSection background-color="secondary" padding="large">
        <div class="scc-error-code scc-container">
            <div class="scc-container__row">
                <div class="scc-container__column scc-container__lg-column--8 scc-container__lg-offset--2">
                    <h1 class="kwf-title title">{{ title }}</h1>
                </div>
                <div class="scc-container__column scc-container__lg-column--6 scc-container__lg-offset--3">
                    <p class="scc-error-code__text">{{ subtitle }}</p>
                </div>
            </div>
            <div class="scc-container__row">
                <div class="scc-container__column scc-container__lg-column--4">
                    <SmallCtaBox
                        :title="box1Title"
                        :content1="box1Paragraph"
                        :buttonText="box1ButtonText"
                        border="bottom"
                        margin="small"
                    />
                </div>
                <div class="scc-container__column scc-container__lg-column--4">
                    <PrizeTeaser v-bind="prizeTeaser" class="scc-error-code__box" margin="medium" />
                </div>
                <div class="scc-container__column scc-container__lg-column--4">
                    <PrizeFiller
                        backgroundColor="white"
                        :icon="box3Image"
                        :title="box3Title"
                        :buttonText="box3ButtonText"
                        :buttonLinkTo="box3ButtonLink"
                        :fillHeight="true"
                    />
                </div>
            </div>
        </div>
    </AppSection>
</template>

<script>
import AppSection from './AppSection';
import PrizeTeaser from '../drawings/PrizeTeaser';

import './error-code.scss';
import SmallCtaBox from './SmallCtaBox';
import PrizeFiller from '../drawings/PrizeFiller';

export default {
    name: 'ErrorCode',
    components: { PrizeFiller, SmallCtaBox, AppSection, PrizeTeaser },
    __editor: {
        fields: {
            prizeTeaserImage: {
                widget: 'media',
            },
            box3Image: {
                widget: 'media',
            },
        },
    },
    props: {
        title: {
            type: String,
            default: 'Sorry, er ging iets mis',
        },
        subtitle: {
            type: String,
            default:
                'De pagina die je zoekt bestaat helaas niet (meer). Waar ben je naar op zoek? We helpen je graag weer op het goede spoor.',
        },
        box1Title: {
            type: String,
            default: 'Speel mee en win',
        },
        box1Paragraph: {
            type: String,
            default:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tincidunt, mi volutpat rutrum iaculis, diam metus tempus eros, et imperdiet diam turpis at justo.',
        },
        box1ButtonText: {
            type: String,
            default: 'Speel mee',
        },
        prizeTeaserLabel: {
            type: String,
            default: 'win',
        },
        prizeTeaserImage: {
            type: String,
            default: 'https://www.placehold.it/500x500',
        },
        prizeTeaserText: {
            type: String,
            default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        },
        prizeTeaserButtonText: {
            type: String,
            default: 'Naar de prijzen',
        },
        box3Image: {
            type: String,
            default: 'http://www.placehold.it/95x95',
        },
        box3Title: {
            type: String,
            default: 'Lees hier de antwoorden op veelgestelde vragen',
        },
        box3ButtonText: {
            type: String,
            default: 'Naar de veelgestelde vragen',
        },
        box3ButtonLink: {
            type: String,
            default: 'veelgestelde-vragen',
        },
    },
    computed: {
        prizeTeaser() {
            return {
                label: this.prizeTeaserLabel,
                image: this.prizeTeaserImage,
                text: this.prizeTeaserText,
                buttonText: this.prizeTeaserButtonText,
                buttonLinkTo: 'prijzen',
            };
        },
    },
};
</script>
